export default {
  data() {
    return {
      orderItems: [],
      byMonths: [],

      distributorSelected: null,
      sellerSelected: null,
      campaignSelected: null,
      startDate: null,
      endDate: null,
      searchQuery: null,
    };
  },

  computed: {
    isBySeller() {
      return this.$route.path.includes('by-seller');
    },

    isLiquidated() {
      return this.$route.path.includes('liquidated');
    },

    mixLiquidationFilters() {
      return {
        isBySeller: this.isBySeller,
        liquidated: this.isLiquidated,
        distributorSelected: this.distributorSelected,
        sellerSelected: this.sellerSelected,
        campaignSelected: this.campaignSelected,
        startDate: this.startDate,
        endDate: this.endDate,
        searchQuery: this.searchQuery,
      };
    },
  },

  methods: {
    distributorSelect(distributorId) {
      this.distributorSelected = distributorId;
    },

    sellerSelect(sellerId) {
      this.sellerSelected = sellerId;
    },

    campaignSelect(campaignId) {
      this.campaignSelected = campaignId;
    },

    datesSelect(startDate, endDate) {
      this.startDate = startDate;
      this.endDate = endDate;
    },

    search(query) {
      this.searchQuery = query;
    },

    mixDownloadPdf() {
      let dynamicFilters = {};

      if (this.isBySeller) {
        dynamicFilters['filter[seller_liquidated]'] = Boolean(this.isLiquidated);
      } else {
        dynamicFilters['filter[distributor_liquidated]'] = Boolean(this.isLiquidated);
      }

      const params = {
        ...dynamicFilters,
        'filter[seller]': this.sellerSelected,
        'filter[distributor]': this.distributorSelected,
        'filter[campaign]': this.campaignSelected,
        'filter[liquidated]': 1,
        'filter[rangeDate]': this.startDate && this.endDate ? `${this.startDate},${this.endDate}` : null,
        'filter[search]': this.searchQuery,
        include: ['order.producer.distributor.seller', 'article.campaign'],
      };

      this.$services.resource('liquidations').byItemsPdf(params, 'liquidaciones');
    },

    mixNewInvoice() {
      this.$router.push({ name: 'InvoiceLiquidationForm', params: { bySeller: this.isBySeller } });
    },
  },
};
